import { useCurrentCarAnnouncementAuctionPause } from './events/currentCarAnnouncement/useCurrentCarAnnouncementAuctionPause'
import { useCurrentCarAnnouncementAuctionResume } from './events/currentCarAnnouncement/useCurrentCarAnnouncementAuctionResume'
import { useCurrentCarAnnouncementBidDeleted } from './events/currentCarAnnouncement/useCurrentCarAnnouncementBidDeleted'
import { useCurrentCarAnnouncementBidOnAgent } from './events/currentCarAnnouncement/useCurrentCarAnnouncementBidOnAgent'
import { useCurrentCarAnnouncementCarEnterHotbid } from './events/currentCarAnnouncement/useCurrentCarAnnouncementCarEnterHotbid'
import { useCurrentCarAnnouncementCarFinished } from './events/currentCarAnnouncement/useCurrentCarAnnouncementCarFinished'
import { useCurrentCarAnnouncementCarHotbidReset } from './events/currentCarAnnouncement/useCurrentCarAnnouncementCarHotbidReset'
import { useCurrentCarAnnouncementItemPublish } from './events/currentCarAnnouncement/useCurrentCarAnnouncementItemPublish'
import { useCurrentCarAnnouncementItemWithdrawOrDelete } from './events/currentCarAnnouncement/useCurrentCarAnnouncementItemWithdrawOrDelete'
import { useCurrentCarAnnouncementUserBid } from './events/currentCarAnnouncement/useCurrentCarAnnouncementUserBid'

export const CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK
  = 'current-car-announcement-update'

export function useCurrentCarAnnouncementSocket() {
  const { userBid } = useCurrentCarAnnouncementUserBid()
  const { auctionPause } = useCurrentCarAnnouncementAuctionPause()
  const { auctionResume } = useCurrentCarAnnouncementAuctionResume()
  const { itemPublish } = useCurrentCarAnnouncementItemPublish()
  const { itemWithdrawOrDelete }
    = useCurrentCarAnnouncementItemWithdrawOrDelete()
  const { bidDeleted } = useCurrentCarAnnouncementBidDeleted()
  const { carEnterHotbid } = useCurrentCarAnnouncementCarEnterHotbid()
  const { carHotbidReset } = useCurrentCarAnnouncementCarHotbidReset()
  const { carFinished } = useCurrentCarAnnouncementCarFinished()
  const { bidOnAgent } = useCurrentCarAnnouncementBidOnAgent()

  const init = () => {
    userBid()
    auctionPause()
    auctionResume()
    itemPublish()
    itemWithdrawOrDelete()
    bidDeleted()
    carEnterHotbid()
    carHotbidReset()
    carFinished()
    bidOnAgent()
  }

  return { init }
}
